export const statuses = [
	{ text: 'Manga' },
	{
		text: 'Novels',
	},
	{
		text: 'One Shots',
	},
	{
		text: 'Doujin',
	},
	{
		text: 'Manhwa',
	},
	{
		text: 'Manhua',
	},
];
